import React, {Component} from 'react';
import {connect} from 'react-redux';
import {reduxForm, formValueSelector} from 'redux-form';
import {Actions} from '../../../common/actions';
import {CHECKING_FORM} from '../../../common/forms';
import {Card, Dropdown, Button, Icon, Popup} from 'semantic-ui-react';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {paths} from '../../../common/dictionaries/urls';
import StorageCarInfoModal from './modal/storageCarInfo';
import ProgressBar from '../../../common/components/progressBar';
import {tabKeyCode, enterKeyCode} from '../../../common/constants/keyCodes';
import CheckingTable from './table';
import './checking.scss';

class CheckingForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'invoiceTmp': '',
      'selectedInvoice': '',
    };
  }

  componentDidMount() {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.BinningChecking,
        scopes.See
      )
    ) {
      this.props.push(paths.AccessDenied);
      return;
    }
    const {invoice} = this.props;
    this.setState({
      'invoiceTmp': invoice ? invoice : '',
      'selectedInvoice': invoice ? invoice : '',
    });
    this.props.emptyInfo();
    this.props.clearItems();
    this.props.fetchPendingInvoicesToBin();
    this.props.fetchSystemParameter('CARSNUMBER');
    this.props.fetchStorageCars('opened');
    if (invoice) {
      this.getInitialData();
    }
  }

  getInitialData() {
    const {invoice} = this.props;
    this.props.fetchInvoiceInfo(invoice);
    this.props.fetchStorageCars('occupied');
    this.props.fetchInvoiceLinesCheckStatus(invoice);
  }

  getInvoices() {
    return this.props.invoices.map((item) => {
      return {'text': item.invoice, 'value': item.invoice};
    });
  }

  changeInvoice(value) {
    this.setState({'invoiceTmp': value}, () => this.updateDataForInvoice());
  }

  updateDataForInvoice() {
    const {selectedInvoice, invoiceTmp} = this.state;
    if (selectedInvoice === invoiceTmp) {
      return;
    }
    this.setState({'selectedInvoice': invoiceTmp});
    this.props.emptyInfo();
    this.props.clearItems();
    this.props.fetchInvoiceInfo(invoiceTmp);
    this.props.fetchInvoiceLinesCheckStatus(invoiceTmp);
    this.props.fetchStorageCars('occupied');
    this.props.fetchStorageCars('opened');
  }

  validateInvoicesFiltered(event) {
    const container = document.getElementsByName('list-invoices-container')[0];
    const element = container.getElementsByClassName('message');

    if (
      (event.keyCode === tabKeyCode || event.keyCode === enterKeyCode) &&
      element.length === 1
    ) {
      event.stopPropagation();
      event.preventDefault();
    }
  }

  onRefreshClick() {
    this.setState({
      'invoiceTmp': '',
      'selectedInvoice': '',
    });
    this.props.emptyInfo();
    this.props.clearItems();
    this.props.fetchPendingInvoicesToBin();
    this.props.fetchStorageCars('opened');
  }

  onVerifyClick() {
    this.props.push(`/binning/chequeo/${this.state.selectedInvoice}/verificar`);
  }

  renderProgressBar() {
    if (this.state.selectedInvoice === '') {
      return null;
    }

    const {loadingLinesStatus, invoiceInfo} = this.props;

    return (
      <ProgressBar
        label={'Líneas'}
        loading={loadingLinesStatus}
        partialQuantity={invoiceInfo.checkedLines}
        totalQuantity={invoiceInfo.invoiceLines}
      />
    );
  }

  renderStorageCarsOpenedSection() {
    const {listStorageCarsOpened} = this.props;
    if (!listStorageCarsOpened.length) {
      return null;
    }

    return listStorageCarsOpened.map((storageCar, index) => {
      return <StorageCarInfoModal key={index} storageCar={storageCar} />;
    });
  }

  render() {
    const {loadingInvoices, invoiceInfo, newItems, lastStorageCarSelected, fetchStorageCars} = this.props;
    const {invoiceTmp, selectedInvoice} = this.state;
    const providerOrigin = invoiceInfo.providerOrigin ?
      ` | ${invoiceInfo.providerOrigin}` :
      '';

    return (
      <div className='checking-page'>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <h2>Binning - Chequeo</h2>
              <div className='title-bar-actions'>
                {this.renderProgressBar()}
              </div>
            </div>
            <div className='actions'>
              <div className='filters-section'>
                <Dropdown
                  selection
                  options={this.getInvoices()}
                  search
                  name='list-invoices-container'
                  value={invoiceTmp}
                  disabled={loadingInvoices}
                  loading={loadingInvoices}
                  onChange={(e, {value}) => this.changeInvoice(value)}
                  onKeyDown={(e) => this.validateInvoicesFiltered(e)}
                  placeholder='Seleccione Factura'
                  noResultsMessage='Factura no encontrada'
                />
                <Button
                  type='button'
                  primary
                  className='toyota-primary refresh'
                  disabled={loadingInvoices}
                  loading={loadingInvoices}
                  onClick={this.onRefreshClick.bind(this)}
                >
                  <Icon name='refresh' size='large' />
                </Button>

                <Button
                  type='button'
                  primary
                  className='toyota-primary'
                  disabled={!selectedInvoice}
                  onClick={this.onVerifyClick.bind(this)}
                >
                  Verificar
                </Button>
                <Popup
                  trigger={
                    <Icon link name='info circle' color='blue' size='big' />
                  }
                  on='click'
                  position='bottom left'
                  inverted
                >
                  <div>
                    Permite validar los items que aún están pendientes de
                    revisión
                  </div>
                </Popup>
              </div>
              <div className='storage-cars-opened-section'>
                {this.renderStorageCarsOpenedSection()}
              </div>
            </div>
            {selectedInvoice && (
              <div className='subtitle'>
                {invoiceInfo.providerName} {providerOrigin}
              </div>
            )}
          </div>
        </Card>
        <CheckingTable
          lastStorageCarSelected={lastStorageCarSelected}
          selectedInvoice={selectedInvoice}
          newItems={newItems}
          fetchStorageCars={fetchStorageCars}
        />
      </div>
    );
  }
}

export {CheckingForm};

const form = reduxForm({
  'form': CHECKING_FORM.name,
})(CheckingForm);

const mapStateToProps = (state, ownProps) => {
  const {invoice} = ownProps.params;
  const {loadingLinesStatus, savingLineInfo} = state.checking;
  const formValues = formValueSelector(CHECKING_FORM.name);
  let newItems = ownProps.newItems || [];
  if (!loadingLinesStatus && !savingLineInfo) {
    newItems = formValues(state, 'newItems');
  }
  return {
    invoice,
    'loadingInvoices': state.checking.loadingInvoices,
    'invoices': state.checking.listInvoices,
    'loadingInvoiceInfo': state.checking.loadingInvoiceInfo,
    'loadingLinesStatus': state.checking.loadingLinesStatus,
    'invoiceInfo': state.checking.invoiceInfo,
    'listStorageCarsOpened': state.checking.listStorageCarsOpened,
    newItems,
    'lastStorageCarSelected': state.form.checking.lastStorageCarSelected,
    'savingLineInfo': state.checking.savingLineInfo,
    'menuSelected': state.menu.selected,
    'permissions': state.session.permissions,
    'push': ownProps.history.push,
  };
};

const {
  fetchPendingInvoicesToBin,
  fetchInvoiceInfo,
  fetchInvoiceLinesCheckStatus,
  fetchSystemParameter,
  fetchStorageCars,
  emptyInfo,
  clearItems,
  withRouter,
} = Actions;

export default withRouter(
  connect(mapStateToProps, {
    fetchPendingInvoicesToBin,
    fetchInvoiceInfo,
    fetchInvoiceLinesCheckStatus,
    fetchSystemParameter,
    fetchStorageCars,
    emptyInfo,
    clearItems,
  })(form)
);
